import { useAtomValue, useSetAtom } from "jotai";
import {
  unresolvedDeductionsCardAtom,
  raisedForDisputeCardAtom,
  deductionsGrossSalesCardAtom,
  tradeLinkedDeductionsCardAtom,
  ScoreCardData,
  fetchAnalyticsScoreCardsAtom,
} from "@/store/analytics";

interface UseAnalyticsScoreCards {
  unresolvedDeductions: ScoreCardData;
  raisedForDispute: ScoreCardData;
  deductionsGrossSales: ScoreCardData;
  tradeLinkedDeductions: ScoreCardData;
  fetchAnalyticsScoreCards: () => void;
}

export const useAnalyticsScoreCards = (): UseAnalyticsScoreCards => {
  const unresolvedDeductions = useAtomValue(unresolvedDeductionsCardAtom);
  const raisedForDispute = useAtomValue(raisedForDisputeCardAtom);
  const deductionsGrossSales = useAtomValue(deductionsGrossSalesCardAtom);
  const tradeLinkedDeductions = useAtomValue(tradeLinkedDeductionsCardAtom);

  const fetchAnalyticsScoreCards = useSetAtom(fetchAnalyticsScoreCardsAtom);

  return {
    unresolvedDeductions,
    raisedForDispute,
    deductionsGrossSales,
    tradeLinkedDeductions,
    fetchAnalyticsScoreCards,
  };
};
